export default __webpack_public_path__ + "assets/361500d6fa46e00effc4415da95564aa.png";